<template>
  <FlexCol gap-3>
    <Flex justify-end gap-3>
      <ButtonExport :api="route" name="Exportar Mos Baixados" v-model:filters="osFilter" />
      <Button primary icon="fa-solid fa-plus" label="Adicionar Mos" @click="openAddDialog" />
    </Flex>

    <TheTable :headers="headersMos" :items="items" disablePagination :loader="loader" dense cell-border>
      <template #idMos="{ item }">
        <span class="roboto-mono-400">{{ formatMos(item.idMos) }}</span> -
        <span v-if="item.mosName">{{ item.mosName }}</span>
        <span v-else class="italic"> MOS Não Registrado </span>
      </template>

      <template #quantity1="{ item }">
        {{ formatQuantity(item.quantity1) }}
      </template>
      <template #quantity2="{ item }">
        {{ formatQuantity(item.quantity2) }}
      </template>
      <template #quantity3="{ item }">
        {{ formatQuantity(item.quantity3) }}
      </template>

      <template #total="{ item }">
        {{ sumTotal(item).toFixed(2) }}
      </template>
      <template #action="{ item }">
        <Flex gap-2>
          <TheToolTip label="Editar">
            <TableIconButton icon="fa-pen" @click="openServiceDialog(item)" />
          </TheToolTip>
          <TheToolTip label="Excluir">
            <TableIconButton class="fa-trash" @click="openCancelDialog(item)" />
          </TheToolTip>
        </Flex>
      </template>
    </TheTable>

    <Modal title="Editar Mos" v-model="dialogService" size="w-4/12">
      <template #default>
        <FlexCol gap-5>
          <InputZoom
            v-model="objectService.idMos"
            label="MOS"
            database="mos"
            itemText="name"
            itemValue="code"
            v-model:completeObject="mos"
            required
            :error="errors.idMos ? [errors.idMos] : null"
            clearable />
          <Grid cols-3 gap-3>
            <InputNumber v-model="objectService.quantity1" label="Quantidade 1" required :error="errors.quantity1" />
            <!-- <InputNumber v-if="mos.quantity2" v-model="objectService.quantity2" label="Quantidade 2" :required="mos.quantity2" :error="errors.quantity2" /> -->
            <InputNumber v-model="objectService.quantity2" label="Quantidade 2" :required="mos.quantity2" :error="errors.quantity2" />
            <!-- <InputNumber v-if="mos.quantity3" v-model="objectService.quantity3" label="Quantidade 3" :required="mos.quantity3" :error="errors.quantity3" /> -->
            <InputNumber v-model="objectService.quantity3" label="Quantidade 3" :required="mos.quantity3" :error="errors.quantity3" />
          </Grid>
          <div class="border-b"></div>
        </FlexCol>
      </template>
      <template v-slot:footer>
        <Button primary icon="fa-solid fa-save" label="Salvar" @click="save()" />
        <Button danger label="Cancelar" @click="cancelDialog" />
      </template>
    </Modal>

    <Modal title="Remover Mos" v-model="dialogDelete" size="w-3/12">
      <template v-slot:default> Deseja remove o serviço? </template>
      <template v-slot:footer>
        <Button primary label="Remover" @click="removeAcept()" />
        <Button danger label="Cancelar" @click="cancelDialog" />
      </template>
    </Modal>
  </FlexCol>
</template>

<script setup>
// Imports
import { computed, ref, onMounted, watch } from 'vue'
import { get, insert, update, remove } from '@/crud'
import { useStore } from 'vuex'
import { useFormat } from '@/composables/useFormat'
// Composables
const { formatMos } = useFormat()
const emits = defineEmits(['osMosData'])
const store = useStore()
// Props
const props = defineProps({
  protocolo: String,
  idOs: Number,
})
// Variables
const route = 'osMos'
const dialogService = ref(false)
const dialogDelete = ref(false)
const objectService = ref(null)
const loader = ref(false)
const items = ref([])
const errors = ref({})
const mos = ref({})

const headersMos = [
  { title: 'MOS', field: 'idMos', disableOrder: true },
  // { title: 'Serviço', field: 'mosIdService', width: '120px', disableOrder: true },
  { title: 'Quantidade 1', field: 'quantity1', width: '120px', disableOrder: true },
  { title: 'Quantidade 2', field: 'quantity2', width: '120px', disableOrder: true },
  { title: 'Quantidade 3', field: 'quantity3', width: '120px', disableOrder: true },
  { title: 'Total', field: 'total', width: '120px', disableOrder: true },
  { title: 'Ações', field: 'action', disableOrder: true },
]

// Computeds
const osFilter = computed(() => {
  return [{ column: 'protocolo', operator: '=', value: props.protocolo }]
})

// Methods
const openAddDialog = () => {
  errors.value = {}
  objectService.value = {}
  dialogService.value = true
}

const openServiceDialog = (service) => {
  errors.value = {}
  objectService.value = { ...service }
  if (service.quantity1) {
    objectService.value.quantity1 /= 100
  }
  if (service.quantity2) {
    objectService.value.quantity2 /= 100
  }
  if (service.quantity3) {
    objectService.value.quantity3 /= 100
  }
  dialogService.value = true
}

const openCancelDialog = (service) => {
  objectService.value = service
  dialogDelete.value = true
}

const formatQuantity = (value) => {
  if (!value) {
    return null
  }
  return (value / 100).toFixed(2)
}

const sumTotal = (item) => {
  let total = 0
  if (item.quantity1) {
    total = item.quantity1 / 100
  }
  if (item.quantity2) {
    total *= item.quantity2 / 100
  }
  if (item.quantity3) {
    total *= item.quantity3 / 100
  }
  return total
}

const cancelDialog = () => {
  dialogService.value = false
  dialogDelete.value = false
}

const loadItem = async () => {
  if (props.protocolo) {
    loader.value = true
    const query = { params: { filters: [{ column: 'protocolo', value: props.protocolo }] } }
    const response = await get(route, query)
    // response.data.forEach((element) => {
    //   element.quantity1 /= 100
    //   element.quantity2 /= 100
    //   element.quantity3 /= 100
    // })
    items.value = response.data

    emits('osMosData', {
      headers: headersMos,
      content: response.data,
    })

    loader.value = false
  }
}

const save = async () => {
  let response
  const id = objectService.value.id

  const object = {
    idOs: props.idOs,
    protocolo: props.protocolo,
    idMos: objectService.value.idMos,
    mosIdService: objectService.value.mosIdService,
    quantity1: objectService.value.quantity1 * 100,
    quantity2: objectService.value.quantity2 * 100,
    quantity3: objectService.value.quantity3 * 100,
  }

  if (id) {
    response = await update(route, id, object, 'mos')
  } else {
    response = await insert(route, object, 'mos')
  }
  errors.value = response.error ? response.data : {}
  if (!response.error) {
    dialogService.value = false
    await loadItem()
  }
}

const removeAcept = async () => {
  const result = await remove(route, objectService.value.id)
  if (result && !result.error) {
    store.dispatch('setSuccess', { message: 'Removido com Sucesso' })
  } else {
    store.dispatch('setError', { message: result.data })
  }
  await loadItem()
  cancelDialog()
}

//  Hooks
onMounted(() => {
  loadItem()
})

// Watchers
watch(
  props,
  () => {
    loadItem()
  },
  { deep: true }
)
</script>
